import { render, staticRenderFns } from "./applyingForResidency.vue?vue&type=template&id=15d82988&scoped=true&"
import script from "./applyingForResidency.vue?vue&type=script&lang=js&"
export * from "./applyingForResidency.vue?vue&type=script&lang=js&"
import style0 from "./applyingForResidency.vue?vue&type=style&index=0&id=15d82988&prod&lang=less&scoped=true&"
import style1 from "./applyingForResidency.vue?vue&type=style&index=1&id=15d82988&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d82988",
  null
  
)

export default component.exports